export enum AuthTokenErrorCodeEnum {
  /**
   * 유효하지 않은 값의 인증/갱신 토큰인 경우
   */
  INVALID_TOKEN_VALUE = 'INVALID_TOKEN',
  /**
   * 토큰 헤더가 없거나 헤더 값이 존재하지 않은 경우
   */
  TOKEN_NOT_FOUND = 'NOT_FOUND_JWT',
  /**
   * 토큰 타입이 Bearer 형식이 아닌 경우;
   */
  UNSUPPORTED_TOKEN_TYPE = 'UNSUPPORTED_JWT',
  /**
   * 접근(ACCESS) 토큰이 만료된 경우
   */
  EXPRIED_ACCESS_TOKEN = 'EXPIRED',
  /**
   * 갱신(REFRESH) 토큰이 만료된 경우
   */
  EXPRIED_REFRESH_TOKEN = 'EXPIRED_REFRESH',
  /**
   * 접근 토큰이 DB에 존재하지 않는 경우
   */
  ACCESS_TOKEN_NOT_FOUND = 'NOT_FOUND_ACCESS',
  /**
   * 갱신 토큰이 DB에 존재하지 않는 경우
   */
  REFRESH_TOKEN_NOT_FOUND = 'NOT_FOUND_REFRESH',
}

export enum LoginErrorCodeEnum {
  /**
   * 잘못된 JSON 포맷으로 요청한 경우
   */
  INPUT_VALUE = 'INPUT_VALUE',
  /**
   * 잘못된 형식으로 요청한 경우
   */
  INPUT_FORMAT = 'INPUT_FORMAT',
  /**
   * 인증(로그인)이 실패한 경우
   */
  LOGIN_FAILED = 'LOGIN_FAILED',
}
